import { generateURL, trackError } from 'utils/helpers';

const checkout = {
  client_token: () => {
    const url = generateURL('/checkout/client_token');

    return fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then((response) => response.json());
  },

  checkout_booking: ({
    payment_data_nonce,
    uid,
    payment_type_id,
    reference,
    payBalance,
    amount_in_cents,
    subscribe_to_email_list,
    payment_method_token,
    voucher_payments,
    device_data,
    three_d_secure_authentication_id,
    gift_cards,
    recaptcha_token,
    turnstile_token,
  }) => {
    const params = {};
    if (recaptcha_token) params['g-recaptcha-response'] = recaptcha_token;
    const url = generateURL('/checkout/create', params);
    const body = {
      payment_data_nonce,
      uid,
      payment_type_id,
      reference,
      balance: payBalance,
      amount_in_cents,
      subscribe_to_email_list,
      payment_method_token,
      voucher_payments,
      device_data,
      three_d_secure_authentication_id,
      gift_cards,
    };
    if (turnstile_token) body['cf-turnstile-response'] = turnstile_token;
    return fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.error !== undefined) {
          return Promise.reject(new Error(data.error));
        }
        return data;
      });
  },

  checkout_status: ({ checkout_id, keepBooking }) => {
    const url = generateURL(`/checkout/status/${checkout_id}`, {
      keep_booking: keepBooking,
    });

    return fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then((response) => response.json());
  },

  makeVaultDefault: (token) => {
    const url = generateURL(`/checkout/vault/${token}/make_default`);
    return fetch(url, {
      method: 'PUT',
    }).then((response) => {
      if (response.status > 299) {
        return Promise.reject(new Error('Failed to set card as default.'));
      }
      return response.json();
    });
  },

  deleteVault: (token) => {
    const url = generateURL(`/checkout/vault/${token}`);
    return fetch(url, {
      method: 'DELETE',
    })
      .then((response) => response.json())
      .catch((error) => {
        trackError(error);

        return {
          message: error.message,
        };
      });
  },

  checkVoucherBalance: (voucherCode) => {
    const url = generateURL(
      `/checkout/check_voucher_balance?short_code=${voucherCode}`
    );
    return fetch(url, {
      method: 'GET',
    }).then((response) => {
      if (response.status > 299) {
        const message = `Voucher code ${voucherCode} is invalid`;
        return Promise.reject(new Error(message));
      }
      return response.json();
    });
  },
};

export default checkout;
